



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Audit extends Vue {
    private loading = false;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];


    created() {
        this.reload();
    }

    reload() {
        this.$apis.getUsersNeedAudit(this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            
            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delUsers({ data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 审核通过
    onAudit(id: number) {
        this.$confirm('确定要通过用户注册申请么？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            
            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.putUserAudit({ ids: ids  })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '审核成功!'
                    });
                });
        });
    }
}
